// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"131":"9f002480","346":"9f002480","934":"9f002480"}[chunkId] + ".chunk.css";
};